import {
	roles,
	users,
	conversions,
	capacities,
	organizations,
	genericTemplates,
} from "api/state";
import { RESET_ORGANIZATION, RESET } from "./actions";

const keep = [
	'connect',
	roles.index,
	users.index,
	conversions.index,
	capacities.index,
	organizations.index,
	genericTemplates.index,
];

/**
 * Clear contacts, segments on APP.RESET_ORGANIZATION
 * @param {Object} state - The state
 * @param {Object} action - The action
 * @returns {Object} The state
 */
export function cleanOnResetOrganization(state, { type }) {
	if (type !== RESET_ORGANIZATION) {
		// Unless RESET_ORGANIZATION do nothing
		return state;
	}
	return keep.reduce((nextState, key) => {
		if (state[key]) {
			nextState[key] = state[key];
		}
		return nextState;
	}, {});
}

/**
 * Clear contacts, segments on APP.RESET_ORGANIZATION
 * @param {Object} state - The state
 * @param {Object} action - The action
 * @returns {Object} The state
 */
export function cleanOnReset(state, { type }) {
	if (type !== RESET) {
		// Unless RESET do nothing
		return state;
	}

	// only keep connect key in the state
	return {
		connect: state.connect || undefined,
	};
}
